import React from 'react';
import Seo from '../components/common/Seo';
import ManufacturingHero from '../components/manufacturing/ManufacturingHero';
import ManufacturingCapacity from '../components/manufacturing/ManufacturingCapacity';
import ManufacturingFacilitiesTable from '../components/manufacturing/ManufacturingFacilitiesTable';

const Manufacturing = () => {
  return (
    <div>
      <Seo
        title="Agastya Agro Limited | Manufacturing, Capacity, and Quality Standards"
        description="Take a closer look at Agastya Agro's production capacity, quality controls, and facilities behind consistent product performance."
      />
      <ManufacturingHero />
      <ManufacturingCapacity />
      <ManufacturingFacilitiesTable />
    </div>
  );
};

export default Manufacturing;
